import api from 'apis/restaurant-api/api';
import { PaginatedResults, RestaurantApiCursorPaginationParams } from 'apis/restaurant-api/types';

import { Settlement } from './types';

export const fetchSettlements = async ({
  venueId,
  limit,
  cursor,
  pivotId,
}: RestaurantApiCursorPaginationParams<{ venueId?: string }>) => {
  const response = await api.get<PaginatedResults<Settlement[]>>(`/v1/merchant-admin/venues/${venueId}/settlements`, {
    params: {
      cursor,
      limit,
      // pivot_id causes the API to return a page starting with the purchase whose id is pivot_id
      pivot_id: pivotId,
    },
  });

  return response.data;
};
